import { useState, useEffect } from "react";
import axios from "axios";


// Call this function with the request to be filled in, e.g.: 'count'. To be used as 'const testData = FetchRequest('count')';
export default function FetchRequest(callRequest) {
  // const baseURL = "http://localhost:8080/index/"; //
  const baseURL = window.location.origin + "/index/"; //
  const [data, setData] = useState();
  const compURL = baseURL + callRequest;

  // Fill in header token
  const headers = {
    "X-token": "5B17BA6FAF6F1D2766CAC4E98E11C", //To be filled in as process.env.X-token
  };

  useEffect(() => {
    axios
      .get(compURL, { headers })
      .then((response) => {
        setData(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  if (data !== undefined){
    sessionStorage.setItem(callRequest, JSON.stringify(data))
    }
  
  return data;
}
